import React, {
    ChangeEvent, ReactElement, useState,
} from "react";
import { useSelector} from "react-redux";
import "./SearchFIeld.scss";
import {CloseCircleFilled, SearchOutlined} from "@ant-design/icons";
import {Input} from "antd";
import {getTranslate, TranslateFunction} from "react-localize-redux";
import {InputProps} from "antd/es/input";
import StoreState from "../../../interfaces/store/storeState";
import useSearch from "../../../hooks/useSearch";

interface Props {
    onSearch(val?: string): void

    inputProps: InputProps
}

const SearchField: React.FC<Props> = ({inputProps, onSearch}: Props): ReactElement => {
    const translatePath: string = "components.common.SearchField.SearchField";

    const [searchValue, setSearchValue] = useState<string>("");
    const translate: TranslateFunction = useSelector(({localize}: StoreState) => getTranslate(localize));

    useSearch(onSearch, searchValue);

    return (
        <Input
            className="df-search-field"
            onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
            value={searchValue}
            prefix={(
                <SearchOutlined
                    className="df-search-icon"
                    aria-hidden
                />
            )}
            suffix={searchValue && (
                <CloseCircleFilled
                    onClick={setSearchValue.bind(this, "")}
                    aria-label={translate(`${translatePath}.clearValue.text`) as string}
                />
            )}
            {...inputProps}
        />
    );
};

export default SearchField;
